import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import styles from './TradeRecommendationForm.module.css';
import Input from '../../common/Input/Input';
import Button from '../../common/Button/Button';
// import SearchSelect from '../../common/SearchSelect/SearchSelect'; // dead: unused import
// import Textarea from '../../common/textArea/TextArea'; // moved: now used only in TradeFormFields
// import Select from '../../common/Select/Select'; // moved: now used only in TradeFormFields
// import { VALIDATION_MESSAGES } from '../../../utils/constants'; // moved: now used only in TradeFormFields
// import { API_ENDPOINTS } from '../../../utils/constants'; // moved: now used only in useTradeFormOptions
// import api from '../../../services/api'; // moved: now used only in tradeNotifications / useTradeFormOptions
// import { /* ToastContainer, */ toast } from "react-toastify"; // moved: toast now used only in tradeNotifications
import {
  tradeRecommendationIdOptions,
  defaultTargetStatusOptions,
  exitTypeIdOptions,
} from './tradeFormConstants';
import useTradeFormOptions from './useTradeFormOptions';
// import { dispatchEditNotifications } from './tradeNotifications'; // moved: now used only in tradeFormSubmit
import TradeFormFields from './TradeFormFields';
import { runTradeFormSubmit } from './tradeFormSubmit';
import useInitialTradeValues from './useInitialTradeValues';



const TradeRecommendationForm = ({
  tradeRecommendation,
  onSubmit,
  onCancel,

  fullscreenMode = false,
  onFormDataChange,
  targetStatusOptions: targetStatusOptionsProp = [],
}) => {
  // Turns a stock object into a readable label, e.g. "Reliance (RELIANCE) [2885] - NSE".
  const formatStockLabel = (t) => {
    if (!t) return "";
    return `${t.name} (${t.symbol}) [${t.token}] - ${t.exch_seg || ""}`;
  };

  const [isEditing, setIsEditing] = useState(!!tradeRecommendation);
  // const [scriptIdOptions, setScriptIdOptions] = useState([]); // dead: setter never called, state always []
  const [loading, setLoading] = useState(false);
  const [scriptSearchTerm, setScriptSearchTerm] = useState("");

  // Option/token lists (fetch logic moved to a dedicated hook).
  const { tradeTypeIdOptions, scriptTypeOptions, internalTokens } =
    useTradeFormOptions();

  const now = new Date();
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");

  // const [searchTerm, setSearchTerm] = useState(""); // dead: only used by filteredOptions below
  // const filteredOptions = scriptIdOptions.filter(opt =>   // dead: never consumed in JSX
  //   opt.label.toLowerCase().includes(searchTerm.toLowerCase())
  // );
  const { initialStopLoss, initialTargetOne, initialExitType, initialTargetOneStatus } =
    useInitialTradeValues(tradeRecommendation);


  const {
    register,
    handleSubmit,
    formState: { errors, isDirty },
    reset,
    watch,
    setValue,
  } = useForm({
    defaultValues: {
      tradeRecommendationId: tradeRecommendation?.tradeRecommendationId || '',
      tradeTypeId: tradeRecommendation?.tradeTypeId || '',
      script: tradeRecommendation?.script || '',
      token: tradeRecommendation?.token || '',
      scriptTypeId: tradeRecommendation?.scriptTypeId || '',
      recoDate: tradeRecommendation?.recoDate || new Date().toISOString().split("T")[0],
      recoTime: tradeRecommendation?.recoTime || `${hours}:${minutes}`,
      recoExitDate: tradeRecommendation?.recoExitDate || '',
      recoPriceLow: tradeRecommendation?.recoPriceLow || '',
      recoPriceHigh: tradeRecommendation?.recoPriceHigh || '',
      targetOne: tradeRecommendation?.targetOne || '',
      targetTwo: tradeRecommendation?.targetTwo || '',
      targetThree: tradeRecommendation?.targetThree || '',
      targetOneStatus: tradeRecommendation?.targetOneStatus || '',
      targetTwoStatus: tradeRecommendation?.targetTwoStatus || '',
      targetThreeStatus: tradeRecommendation?.targetThreeStatus || '',
      stopLoss: tradeRecommendation?.stopLoss || '',
      status: tradeRecommendation?.status || '',
      exitTypeId: String(tradeRecommendation?.exitTypeId) || '',
      exitDate: tradeRecommendation?.exitDate || null,
      exitTime: tradeRecommendation?.exitTime || null,
      exitPriceLow: tradeRecommendation?.exitPriceLow || '',
      exitPriceHigh: tradeRecommendation?.exitPriceHigh || '',
      entryNote: tradeRecommendation?.entryNote || '',
      exitNote: tradeRecommendation?.exitNote ?? tradeRecommendation?.exitnote ??
        '',
      track_only: tradeRecommendation?.track_only || false,
    },
  });

  const watchStockId = watch("stockId");
  const watchRecommendationType = watch("recommendationType");
  const watchTargetPrice = watch("targetPrice");
  const watchStopLoss = watch("stopLoss");
  const watchTimeframe = watch("timeframe");
  // const watchExitTypeId = String(watch("exitTypeId") || ""); // dead: never referenced
  const watchScript = watch("script");
  const watchStatus = watch("status");

  const isLiveStatus = String(watchStatus || "").toLowerCase() === "live";

  // dead: selectedToken never referenced
  // const selectedToken = internalTokens.find(
  //   (token) =>
  //     String(token.symbol) === String(watchScript) ||
  //     String(token.token) === String(watchScript),
  // );



  // Report live field values back to the parent page (used for its progress indicator).
  useEffect(() => {
    if (onFormDataChange) {
      onFormDataChange({
        stockId: watchStockId || '',
        recommendationType: watchRecommendationType || '',
        targetPrice: watchTargetPrice || '',
        stopLoss: watchStopLoss || '',
        timeframe: watchTimeframe || ''
      });
    }
  }, [watchStockId, watchRecommendationType, watchTargetPrice, watchStopLoss, watchTimeframe, onFormDataChange]);

  // Edit mode: once the trade AND the dropdown lists are ready, load all its
  // values into the form so the selected options actually match an option.
  useEffect(() => {
    if (tradeRecommendation &&
      tradeTypeIdOptions.length > 0 &&
      scriptTypeOptions.length > 0 &&
      tradeTypeIdOptions.length > 0) {
      reset({
        tradeRecommendationId: tradeRecommendation.tradeRecommendationId || '',
        tradeTypeId: String(tradeRecommendation.tradeTypeId) || '',
        script: tradeRecommendation.script || '',
        token: tradeRecommendation.token || '',
        scriptTypeId: tradeRecommendation.scriptTypeId || '',
        recoDate: tradeRecommendation.recoDate || '',
        recoTime: tradeRecommendation.recoTime || '',
        recoExitDate: tradeRecommendation.recoExitDate || '',
        recoPriceLow: tradeRecommendation.recoPriceLow || '',
        recoPriceHigh: tradeRecommendation.recoPriceHigh || '',
        targetOne: tradeRecommendation.targetOne || '',
        targetTwo: tradeRecommendation.targetTwo || '',
        targetThree: tradeRecommendation.targetThree || '',
        targetOneStatus: tradeRecommendation.targetOneStatus || '',
        targetTwoStatus: tradeRecommendation.targetTwoStatus || '',
        targetThreeStatus: tradeRecommendation.targetThreeStatus || '',
        stopLoss: tradeRecommendation.stopLoss || '',
        status: tradeRecommendation.status || '',
        exitTypeId: String(tradeRecommendation.exitTypeId) || '',
        exitDate: tradeRecommendation.exitDate || '',
        exitTime: tradeRecommendation.exitTime || '',
        exitPriceLow: tradeRecommendation.exitPriceLow || '',
        exitPriceHigh: tradeRecommendation.exitPriceHigh || '',
        entryNote: tradeRecommendation.entryNote || '',
        // exitNote: tradeRecommendation.exitNote || '',
        exitNote: tradeRecommendation?.exitNote ?? tradeRecommendation?.exitnote ??
          '',

        recommendationType: tradeRecommendation.recommendationType || tradeRecommendation.recommendationtype || 'Buy',
        entryPrice: tradeRecommendation.entryPrice || tradeRecommendation.entryprice || '',
        targetPrice: tradeRecommendation.targetPrice || tradeRecommendation.targetprice || '',
        track_only: tradeRecommendation.track_only || false,
      });
      setIsEditing(true);
    }
  }, [tradeRecommendation, tradeTypeIdOptions, scriptTypeOptions, reset]);

  // Effect to set initial search term when internalTokens loads and we have a script value
  useEffect(() => {
    if (tradeRecommendation?.script && internalTokens.length > 0) {

      const tokenObj = internalTokens.find(
        (t) =>
          String(t.symbol) === String(tradeRecommendation.script) ||
          String(t.token) === String(tradeRecommendation.token)
      );

      if (tokenObj) {
        setScriptSearchTerm(formatStockLabel(tokenObj));

        setValue("script", tokenObj.symbol);
        setValue("token", tokenObj.token);
      } else {
        setScriptSearchTerm(String(tradeRecommendation.script));
        setValue("token", tradeRecommendation.token || "");
      }
    }
  }, [tradeRecommendation, internalTokens]);

  // console.log(`initialTargetOneStatus ${initialTargetOneStatus}`);

  // Maps a trade-type id to its label (e.g. 2 -> "Intraday"); used in one notification.
  const fetchduration = (id) => {
    const selectedType = tradeTypeIdOptions.find(
      (option) => String(option.value) === String(id),
    );
    return selectedType?.label || "";
  };

  const watchExitTime = watch("exitTime");
  const watchExitDate = watch("exitDate");
  const watchExitPriceLow = watch("exitPriceLow");
  const watchTargetOne = watch("targetOne");
  const isTargetHit = String(watchStatus || "").toLowerCase() === "target hit";
  const isClosed = String(watchStatus || "").toLowerCase() === "Closed";
  // const recopriceLowdata = watch("recopriceLow"); // dead: field "recopriceLow" never registered → always undefined

  // When the trade is NOT Live (being closed/hit), auto-fill sensible exit values
  // if the user hasn't set them: today's date/time, and an exit price from the
  // target (if target hit) or the stop loss, marked as a Manual exit.
  useEffect(() => {
    if (!isLiveStatus) {
      if (!watchExitDate) {
        setValue("exitDate", new Date().toISOString().split("T")[0], {
          shouldDirty: true,
          shouldValidate: true,
        });
      }
      if (!watchExitTime) {
        const now = new Date();
        const hh = String(now.getHours()).padStart(2, "0");
        const mm = String(now.getMinutes()).padStart(2, "0");
        setValue("exitTime", `${hh}:${mm}`, {
          shouldDirty: true,
          shouldValidate: true,
        });
      }
      if (!watchExitPriceLow) {
        if (isTargetHit && watchTargetOne) {
          setValue("exitPriceLow", watchTargetOne, {
            shouldDirty: true,
            shouldValidate: true,
          });
          setValue("exitTypeId", "1", {
            shouldDirty: true,
            shouldValidate: true,
          });
        } else if (watchStopLoss) {
          setValue("exitPriceLow", watchStopLoss, {
            shouldDirty: true,
            shouldValidate: true,
          });
          setValue("exitTypeId", "1", {
            shouldDirty: true,
            shouldValidate: true,
          });
        }
        else if (isClosed) {
          setValue("exitPriceLow", null, {
            shouldDirty: false,
            shouldValidate: false,
          });
          setValue("exitTypeId", "1", {
            shouldDirty: true,
            shouldValidate: true,
          });
        }
      }





    }
  }, [isLiveStatus, watchExitDate, watchExitTime, setValue, watchTargetOne, watchStopLoss, isClosed /*, recopriceLowdata */]);

  // On save: hand everything the submit flow needs to the extracted helper.
  const onFormSubmit = (data) =>
    runTradeFormSubmit({
      data,
      onSubmit,
      isEditing,
      tradeRecommendation,
      setLoading,
      setValue,
      initialStopLoss,
      initialTargetOne,
      initialExitType,
      initialTargetOneStatus,
      fetchduration,
    });

  // When the trade IS Live, it has no exit yet — clear any exit values.
  useEffect(() => {
    if (isLiveStatus) {
      setValue("exitTypeId", "");
      setValue("exitDate", null);
      setValue("exitTime", null);
      setValue("exitPriceLow", "");
      setValue("exitPriceHigh", "");
      setValue("exitNote", "");
    }
  }, [isLiveStatus, setValue]);

  const handleReset = () => {
    if (tradeRecommendation) {
      reset();
    } else {
      reset({
        stockId: "",
        stockSymbol: "",
        stockName: "",
        recommendationType: "Buy",
        entryPrice: "",
        targetPrice: "",
        stopLoss: "",
        timeframe: "",
        riskLevel: "Medium",
        status: "Active",
        rationale: "",
        technicalIndicators: "",
        fundamentalFactors: "",
      });
    }
  };

  // Use the status list the page provided, otherwise fall back to the default.
  const targetStatusOptions =
    targetStatusOptionsProp.length > 0
      ? targetStatusOptionsProp
      : defaultTargetStatusOptions;

  const formClasses = [styles.form, fullscreenMode ? "fullscreenModal" : ""]
    .filter(Boolean)
    .join(" ");


  return (
    <div className={fullscreenMode ? "fullscreen-form-container" : ""}>
      <form className={formClasses} onSubmit={handleSubmit(onFormSubmit)}>
        {!fullscreenMode && (
          <div className={styles.formHeader}>
            <h2 className={styles.formTitle}>
              {isEditing
                ? "Edit Trade Recommendation"
                : "Create New Trade Recommendation"}
            </h2>
            <p className={styles.formSubtitle}>
              {isEditing
                ? "Update trade recommendation details below"
                : "Fill in the details to create a new trade recommendation"}
            </p>
          </div>
        )}

        <TradeFormFields
          register={register}
          errors={errors}
          setValue={setValue}
          tradeRecommendationIdOptions={tradeRecommendationIdOptions}
          tradeTypeIdOptions={tradeTypeIdOptions}
          targetStatusOptions={targetStatusOptions}
          scriptTypeOptions={scriptTypeOptions}
          exitTypeIdOptions={exitTypeIdOptions}
          scriptSearchTerm={scriptSearchTerm}
          setScriptSearchTerm={setScriptSearchTerm}
          internalTokens={internalTokens}
          isLiveStatus={isLiveStatus}
          watchStatus={watchStatus}
          formatStockLabel={formatStockLabel}
        />

        {!fullscreenMode && (
          <div className={styles.formActions}>
            <Button
              type="button"
              variant="secondary"
              onClick={handleReset}
              disabled={loading}
            >
              Reset
            </Button>

            <Input
              label="Track Only"
              type="checkbox"
              {...register("track_only"
              )}
            // required
            />
            <Button
              type="button"
              variant="outline"
              onClick={onCancel}
              disabled={loading}
            >
              Cancel
            </Button>

            <Button
              type="submit"
              variant="primary"
              loading={loading}
              disabled={loading || (!isDirty && isEditing)}
            >
              {isEditing ? "Update Recommendation" : "Create Recommendation"}
            </Button>
          </div>
        )}

        {isEditing && !isDirty && !fullscreenMode && (
          <div className={styles.noChangesMessage}>
            <span>💡 Make changes to enable the update button</span>
          </div>
        )}
      </form>

      {fullscreenMode && (
        <div
          className={`modal-footer-actions ${styles.modalFooterActions}`}
        >

          <Input
            className={styles.checkboxMarginRight}
            type="checkbox"
            label="Track Only"
            {...register("track_only"
            )}
          // required
          />
          <Button
            type="button"
            variant="outline"
            onClick={onCancel}
            disabled={loading}
          >
            Cancel
          </Button>

          <Button
            type="submit"
            variant="primary"
            loading={loading}
            disabled={loading || (!isDirty && isEditing)}
            onClick={handleSubmit(onFormSubmit)}
          >
            {loading
              ? "Saving..."
              : isEditing
                ? "Update Recommendation"
                : "Create Recommendation"}
          </Button>
        </div>
      )}
    </div>
  );
};

export default TradeRecommendationForm;
